import React from 'react';
import { Button, FormGroup } from 'reactstrap';
import { compose, withHandlers } from 'recompose';
import { isFunction, isObject, omit } from 'lodash';
import moment from 'moment';

export const OrderTemplate = ({ onButtonClick, ...props }) => (
  <FormGroup {...props} className="job-status-template clearfix">
    <Button className="pull-right" color="primary" onClick={onButtonClick}>
      Job Status Template
    </Button>
  </FormGroup>
);

const enhance = compose(
  withHandlers({
    onButtonClick: ({
      ordering: tmpOrdering,
      limit,
      offset,
      filters,
      search,
      url,
      client,
      filename,
    }) => (...args) => {
      const ordering = tmpOrdering.column
        ? `${tmpOrdering.direction === 2 ? '-' : ''}${tmpOrdering.column}`
        : '';

      let params = { ordering, search, format: 'csv' };
      if (isObject(filters)) {
        params = {
          ...params,
          ...filters,
        };
      }

      params = omit(params,['offset', 'limit'])

      return client
        .get(url, {
          params,
        })
        .tap(({ data }) => {
          const link = document.createElement('a');

          // split data string into each line
          let temp = data.replace(/("[\s\S]*?")/g, (m, cg) => {
            return cg.replace(/\n/g, "LINE-BREAK-TO-PRESERVE");
          }).split('\n')
            .filter(i => Boolean(i.trim()))
            .map(i => i.replace(/LINE-BREAK-TO-PRESERVE/g, '\n'));

          // temp[0] contains the title of each column in CSV
          // we use these as the keys for our JSON
          let keys = temp[0].split(",");

          let json = [];

          // remove first element from temp - so only data rows are left (no titles)
          temp.shift();

          // for each row of data...
          temp.forEach((t, t_idx) => {
            // if we have not reached the end of the data rows...
            if(t_idx < t.length){
              // split data by comma - into individual values
              let split = t.split(",");
              let obj = {};

              // put these data into JSON under respective keys
              keys.forEach((k, k_idx) => {
                obj[k] = split[k_idx];
              })
              json.push(obj);
            }
          })

          // define new order of data for csv file, and coincidentally the only data we want to export as CSV
          const ordering = [
            "jobs.id",
            "jobs.status_text",
            "jobs.appointment_date",
            "jobs.job_completed_at",
          ]

          const titles = [
            "jobNumber",
            "jobStatus",
            "bookedDate",
            "completedDate",
          ]

          let newlyOrdered = "";

          // loop through our newly JSON formatted data, and the ordering schema...
          // ... to re-order data into our new desired order.
          // This will also filter out any unwanted data.
          json.forEach(e => {
            let tempString = "";
            ordering.forEach(o => {
              if(e[o]){
                if (o !== 'jobs.appointment_date' && o !== 'jobs.job_completed_at') {
                  tempString += e[o] + ",";
                } else {
                  tempString += moment(e[o]).format('DD/MM/YYYY') + ",";
                }
              } else {
                // prevents "undefined" appearing in the CSV
                tempString += ",";
              }
            })
            newlyOrdered += tempString + "\n";
          })

          // put data back into same string format as it began, but in new order
          // allows us to contine to use tried-and-tested CSV export code.
          let orderingAsString = "";
          titles.forEach(o => {
            orderingAsString += o + ",";
          })
          let newData = orderingAsString + "\n" + newlyOrdered;

          // download the CSV file
          if(window.navigator.msSaveBlob){
            // Special treatment for IE11
            const blob = new Blob([newData], { type: 'text/csv' });
            window.navigator.msSaveBlob(blob, isFunction(filename) ? filename(moment().format('YYYY-MM-DD_HH-mm')) : filename);
          }else{
            const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + newData);
            link.setAttribute('href', encodedUri);
            link.setAttribute(
              'download',
              isFunction(filename)
                ? filename()
                : filename
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
    },
  })
);

export default enhance(OrderTemplate);



// WEBPACK FOOTER //
// ./src/components/common/OrderImport/OrderTemplate.jsx